<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import type { Content } from '@apparatix/types/AccountProfiles';
import { Stack } from '@apparatix/library/core';

type Props = {
  contents: Content<'list'>;
  columns?: string[];
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'on:change', value: Content<'list'>): void;
}>();

const model = ref<string[] | object[]>([]);

const isObjectList = computed(() => Array.isArray(props.contents) && props.contents.every(item => typeof item === 'object'));
const itemKey = computed(() => {
  if (!props.columns[0]) return undefined;
  return props.columns[0];
});

const onItemChange = () => emit('on:change', model.value);

const onAddItem = () => {
  if (isObjectList.value && itemKey.value) {
    const newItem: object = {};
    newItem[itemKey.value] = '';
    (model.value as object[]).push(newItem);
  } else {
    (model.value as string[]).push('');
  }
};

onMounted(() => {
  if (!Array.isArray(props.contents)) return;
  model.value = [...props.contents] as string[] | object[];
});
</script>
<template>
  <Stack :gap="2">
    <template v-if="isObjectList && itemKey">
      <InputText
        v-for="idx in model.length"
        :key="idx"
        v-model="model[idx - 1][itemKey]"
        size="small"
        fluid
        @value-change="onItemChange"
      />
    </template>
    <template v-else>
      <InputText
        v-for="idx in model.length"
        :key="idx"
        v-model="(model[idx - 1] as string)"
        size="small"
        fluid
        @value-change="onItemChange"
      />
    </template>
    <div>
      <Button
        severity="secondary"
        size="small"
        outlined
        @click="onAddItem"
      >
        Add Item
      </Button>
    </div>
  </Stack>
</template>
